"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClassName = function (defaultClassName, className) {
    return className
        ? className
            .split(' ')
            .concat(defaultClassName)
            .join(' ')
        : defaultClassName.join(' ');
};
//# sourceMappingURL=classname.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mapbox-gl/lib/util/classname.js
// module id = 303
// module chunks = 0